<template>
  <div class="container-fluid py-4">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="fw-bold mb-0">
        <i class="bi bi-pencil-square text-primary me-2"></i> Modifier la fréquence
      </h2>
      <button class="btn btn-outline-secondary btn-sm" @click="$router.push({ name: 'liste_frequence' })">
        <i class="bi bi-arrow-left"></i> Retour à la liste
      </button>
    </div>

    <!-- Formulaire -->
    <div class="card shadow-sm p-4 rounded">
      <div class="card-body">
        <form @submit.prevent="updateFrequence">
          <div class="row g-4">
            <!-- Nom -->
            <div class="col-md-6">
              <label class="form-label fw-semibold">Nom <span class="text-danger">*</span></label>
              <input
                type="text"
                v-model="frequence.nom"
                class="form-control form-control-lg"
                placeholder="Ex : 3 fois par jour"
                required
              />
            </div>

            <!-- Description -->
            <div class="col-md-6">
              <label class="form-label fw-semibold">Description</label>
              <input
                type="text"
                v-model="frequence.description"
                class="form-control form-control-lg"
                placeholder="Ex : Matin, midi et soir"
              />
            </div>

            <!-- Statut -->
            <div class="col-md-6 mt-2">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isEnabled"
                  v-model="frequence.isEnabled"
                />
                <label class="form-check-label fw-semibold" for="isEnabled">
                  Activer la fréquence
                </label>
              </div>
            </div>
          </div>

          <!-- Boutons -->
          <div class="mt-5 d-flex justify-content-end gap-3">
            <button type="button" class="btn btn-outline-secondary px-4" @click="$router.push({ name: 'liste_frequence' })">
              Annuler
            </button>
            <button type="submit" class="btn btn-primary px-4" :disabled="isSaving">
              <span v-if="isSaving">
                <span class="spinner-border spinner-border-sm me-2"></span> Mise à jour...
              </span>
              <span v-else>Mettre à jour</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'EditFrequence',
  data() {
    return {
      isSaving: false,
      isLoading: true,
      frequence: {
        nom: '',
        description: '',
        isEnabled: true
      }
    };
  },
  async mounted() {
    await this.fetchFrequence();
  },
  methods: {
    async fetchFrequence() {
      this.isLoading = true;
      try {
        const id = this.$route.params.id;
        const response = await api.getItem('frequences', id);
        this.frequence = response.data;
      } catch (error) {
        console.error('Erreur lors du chargement de la fréquence :', error);
        alert("Impossible de charger les informations de la fréquence.");
      } finally {
        this.isLoading = false;
      }
    },

    async updateFrequence() {
      if (!this.frequence.nom.trim()) {
        alert('Le nom est obligatoire.');
        return;
      }

      this.isSaving = true;
      try {
        await api.updateItem('frequences', this.$route.params.id, this.frequence);
        this.$router.push({ name: 'liste_frequence' });
      } catch (error) {
        console.error('Erreur lors de la mise à jour de la fréquence :', error);
        alert("Erreur lors de la mise à jour de la fréquence.");
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>

<style scoped>
.card {
  background: #f8fafd;
  border: none;
  border-radius: 16px;
}

.form-control-lg {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  transition: all 0.3s ease;
}

.form-control-lg:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 6px #0d6efd33;
}

.btn-primary {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.btn-outline-secondary {
  border-radius: 10px;
  transition: all 0.3s ease;
}
</style>
